import React from 'react';
import { RestartAltOutlined } from '@mui/icons-material';
import moment from 'moment';
import Tooltip from '@src/components/Tooltip';
import CommonButton from '@src/new-components/Button';
import DateRangePickerCustom from '@src/new-components/DateRangePicker';
import { COLOR } from '@src/styles/color';
import { useTranslation } from 'react-i18next';
import { StyledFilter } from './index.style';

const Filter = ({ selectedDate, handleDateRangeChange, handleResetFilter }) => {
  const { t } = useTranslation();

  const optionsDatePicker = [
    {
      label: t('today'),
      getRange: () => {
        const start = moment().startOf('day').toDate();
        const end = moment().endOf('day').toDate();
        return [start, end];
      },
      key: 'today',
    },
    {
      label: t('lastWeek'),
      key: 'lastWeek',
      getRange: () => {
        const end = moment().endOf('day');
        const start = moment().subtract(7, 'd').startOf('day');
        return [start.toDate(), end.toDate()];
      },
    },
    {
      label: t('30DaysAgo'),
      key: '30DaysAgo',
      getRange: () => {
        const end = moment().endOf('day');
        const start = moment().subtract(30, 'd').startOf('day');
        return [start.toDate(), end.toDate()];
      },
    },
    {
      label: t('thisMonth'),
      key: 'thisMonth',
      getRange: () => {
        const end = moment().endOf('month');
        const start = moment().startOf('month');
        return [start.toDate(), end.toDate()];
      },
    },
    {
      label: t('lastMonth'),
      key: 'lastMonth',
      getRange: () => {
        const end = moment().subtract(1, 'months').endOf('month');
        const start = moment().subtract(1, 'months').startOf('month');
        return [start.toDate(), end.toDate()];
      },
    },
    {
      label: t('thisYear'),
      key: 'thisYear',
      getRange: () => {
        const end = moment().endOf('day');
        const start = moment().startOf('year');
        return [start.toDate(), end.toDate()];
      },
    },
  ];

  return (
    <StyledFilter>
      <div className="filter-container">
        <DateRangePickerCustom
          selectedDate={selectedDate}
          onChange={(value) => {
            const [startDate, endDate] = value.value;

            handleDateRangeChange({
              value: [
                startDate ? moment(startDate).startOf('day').toDate() : null,
                endDate ? moment(endDate).endOf('day').toDate() : null,
              ],
              type: value.type,
              label: value.label,
            });
          }}
          options={optionsDatePicker}
          format="DD/MM/YYYY"
          placeholder={`${t('today')} - ${t('today')}`}
          shouldDisableDate={(date) => moment(date).isAfter(moment(), 'day')}
          width="100%"
          minWidth="226px"
        />
        <Tooltip arrow title={t('reset')} placement="top">
          <div>
            <CommonButton
              customStyle={{
                width: '40px',
                height: '40px',
                minWidth: '40px',
                borderRadius: '8px',
              }}
              variant="outlineSmall"
              disabled={!selectedDate?.value[0] && !selectedDate?.value[1]}
              onClick={handleResetFilter}
            >
              <RestartAltOutlined
                sx={{ fontSize: '24px', color: COLOR.navyBlue }}
              />
            </CommonButton>
          </div>
        </Tooltip>
      </div>
    </StyledFilter>
  );
};

export default Filter;
